/**
 * @generated SignedSource<<32106c66bce126051335fb7268f00256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLInvestigationCategory = "BUILD" | "INFRASTRUCTURE" | "PRODUCT" | "%future added value";
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobRunHeader_jobRun$data = {
  readonly alertEvent: {
    readonly alertDescription: string | null | undefined;
  } | null | undefined;
  readonly createdAt: any;
  readonly digest: {
    readonly id: any;
    readonly summary: string;
  } | null | undefined;
  readonly id: any;
  readonly investigation: {
    readonly category: GraphQLInvestigationCategory;
    readonly id: any;
    readonly services: ReadonlyArray<string> | null | undefined;
    readonly summary: string;
  } | null | undefined;
  readonly job: {
    readonly id: any;
    readonly name: string;
  };
  readonly name: string;
  readonly outputJson: any | null | undefined;
  readonly status: GraphQLJobRunStatus;
  readonly updatedAt: any;
  readonly " $fragmentType": "JobRunHeader_jobRun";
};
export type JobRunHeader_jobRun$key = {
  readonly " $data"?: JobRunHeader_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunHeader_jobRun">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobRunHeader_jobRun",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAlertEvent",
      "kind": "LinkedField",
      "name": "alertEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alertDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJob",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLInvestigation",
      "kind": "LinkedField",
      "name": "investigation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "services",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLDigest",
      "kind": "LinkedField",
      "name": "digest",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "4cf831a767228262d04cd85d3f27966b";

export default node;
